<template>
  <div id="TransformSpot"/>
</template>

<script setup>
import p5 from 'p5'
import {ref, reactive, watchEffect, onUnmounted, watch, onMounted} from 'vue'
import defaultValue from "@/utils/defaultValue";
import colorTool from "@/utils/colorTool";
const {changeToRgb, rgbToHsb} = colorTool()


const {defaultWidth, defaultHeight} = defaultValue()

const props = defineProps(['currentValue', 'effectTheme'])

const effectThemeData = reactive(props.effectTheme)
let canvasWrap = ref('stop')
let animateSpeed = ref(1) // 1, 4, 8
let high = ref(null)
let low = ref(null)
let nowTemperature = ref(null)
let backgroundColor = ref([0,0,0])
let drawPot = ref(0)
let colorLow = ref([])
let colorHigh = ref([])
let currentColorArr = reactive({arr: []})
let animateMode = ref(15)

let highAnimateMode = ref(75)
let lowAnimateMode = ref(15)

const handleDynamicAnimateMode = (high, low, now, colorHigh, colorLow, highAnimateMode, lowAnimateMode ) => {
  // 高低差 range
  let lowHeightRange = Math.ceil((high - low) / 10) // 將高低差 分為 10個單位, 1單位

  // 現在溫度range
  let nowRange = Math.trunc((now - low) / lowHeightRange)
  // 設定速度 & animateMode
  if (nowRange <= 1) {
    // color
    currentColorArr.arr = colorLow.map(color => rgbToHsb(color))
    // animateMode
    animateMode.value = lowAnimateMode
  } else if (nowRange >= 10) {
    // color
    currentColorArr.arr = colorHigh.map(color => rgbToHsb(color))
    // animateMode
    animateMode.value = highAnimateMode
  } else {
    // color
    const colorHighOne = rgbToHsb(colorHigh[0])

    const colorLowOne = rgbToHsb(colorLow[0])

    const nowColorOne = [
      (nowRange * colorHighOne[0] + (10 - nowRange) * colorLowOne[0]) / 10,
      (nowRange * colorHighOne[1] + (10 - nowRange) * colorLowOne[1]) / 10,
      (nowRange * colorHighOne[2] + (10 - nowRange) * colorLowOne[2]) / 10,
    ]
    currentColorArr.arr = [
      nowColorOne
    ]

    if (
        colorHighOne[0] === colorLowOne[0] &&
        colorHighOne[1] === colorLowOne[1] &&
        colorHighOne[2] === colorLowOne[2]
    ) {
      currentColorArr.arr[0] = colorHighOne
    }

    // animateMode
    animateMode.value = Math.abs((lowAnimateMode - highAnimateMode) / nowRange) * 2
  }
}
const transformSpotAnimate = (sketch) => {
	let cw = defaultWidth.value
	let ch = defaultHeight.value
  let centerCircle = 200;
  let rot;
  let col;
  let freq = 0.000005;
  let r;

	sketch.setup = () => {
    sketch.createCanvas(cw, ch);
    sketch.colorMode(sketch.HSB, 360, 100, 100, 255)
  }

	sketch.draw = () => {
    drawPot.value ++
    sketch.background(...backgroundColor.value);
    sketch.translate(sketch.width/2, sketch.height/2);
    sketch.rotate(sketch.radians(rot));

    sketch.ellipseMode(sketch.RADIUS);
    for (let i=0; i<500; i ++) {
      // let circle = centerCircle + 50*sketch.sin(sketch.millis()*freq*i);
      let circle = centerCircle + animateMode.value*sketch.sin(sketch.millis()*freq*i);
      col=sketch.map(circle,0,10,10,0);
      r=sketch.map(circle,150,250,5,2);
      sketch.fill(...currentColorArr.arr ); // spot color
      sketch.noStroke();
      sketch.ellipse(circle*sketch.cos(i), circle*sketch.sin(i),r,r); // spot
      rot=rot+0.00005;
    }
	}
}

function initAnimate () {
  if (canvasWrap.value !== 'stop') {
    canvasWrap.value.remove()
    canvasWrap.value = 'stop'
  }
}

watch(drawPot, (n, o) => {

  if (n > 3600) { // 2min init
    initAnimate()
    canvasWrap.value = new p5(transformSpotAnimate, 'TransformSpot')
    drawPot.value = 0
  }
})

watch(() => effectThemeData.Sensor, (Sensor) => {
  if (Sensor) {
    initAnimate()
    canvasWrap.value =  new p5(transformSpotAnimate, 'TransformSpot')
  }
})

watchEffect(() => {
  const {
    HighValue,
    LowValue,
    IsDynamicMode,
    Speed: rotateSpeed,
    BackgroundColor,
    AnimateMode,
    Colors,
    HighColors,
    LowColors,
    HighAnimateMode,
    LowAnimateMode
  } = effectThemeData

  // 背景色
  backgroundColor.value = typeof BackgroundColor === "object" && BackgroundColor.length > 0 ? rgbToHsb(BackgroundColor) : '[0,0,0]'

  nowTemperature.value = props.currentValue && props.currentValue !== null ? props.currentValue : ''

  if (IsDynamicMode.toString() === 'false') {
    animateMode.value = AnimateMode
    currentColorArr.arr = Colors.map(color => rgbToHsb(color))
    if (rotateSpeed && rotateSpeed > 0) animateSpeed.value = rotateSpeed
  } else if (IsDynamicMode.toString() === 'true') {
    high.value = HighValue
    low.value = LowValue
    colorHigh.value = HighColors
    colorLow.value = LowColors
    highAnimateMode.value = HighAnimateMode
    lowAnimateMode.value = LowAnimateMode
    handleDynamicAnimateMode (
        high.value,
        low.value,
        nowTemperature.value,
        colorHigh.value,
        colorLow.value,
        highAnimateMode.value,
        lowAnimateMode.value
    )
  }

})

onMounted(() => {
  // create p5
  if (canvasWrap.value === 'stop') canvasWrap.value = new p5(transformSpotAnimate, 'TransformSpot')
})


onUnmounted(() => {
  drawPot.value = 0
  nowTemperature.value = null
  backgroundColor.value = [0,0,0]
  high.value = null
  low.value = null
  animateSpeed.value = 1
  currentColorArr.arr = []
  high.value = null
  low.value = null
  colorHigh.value = []
  colorLow.value = []
  initAnimate()
})

</script>
